module.exports = __webpack_public_path__ + "images/0351ef66687c81510d13bf86091fe866.jpg";


//////////////////
// WEBPACK FOOTER
// ../public/images/bottle-loading-image.jpg
// module id = 822
// module chunks = 0